var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import LmsIntegrationDomainService from "../Domain/LmsIntegration/LmsIntegration.service";
const BASE_URL = "/aviso/lmsIntegration";
export default class LmsIntegrationService {
    static get(lmsIntegrationId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse(BASE_URL + "/get", {
                lmsIntegrationId,
            }).then(LmsIntegrationDomainService.fromJSON);
        });
    }
    static search(search, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const searchResults = yield FetchService.getPagedResponse(BASE_URL + "/search", {
                query: search === null || search === void 0 ? void 0 : search.query,
                ids: search === null || search === void 0 ? void 0 : search.ids,
                excludeIds: search === null || search === void 0 ? void 0 : search.excludeIds,
                displayNames: search === null || search === void 0 ? void 0 : search.displayNames,
                internalNames: search === null || search === void 0 ? void 0 : search.internalNames,
                descriptions: search === null || search === void 0 ? void 0 : search.descriptions,
                max: options === null || options === void 0 ? void 0 : options.max,
                offset: options === null || options === void 0 ? void 0 : options.offset,
                sort: options === null || options === void 0 ? void 0 : options.sort,
                order: options === null || options === void 0 ? void 0 : options.order,
            });
            return Object.assign(Object.assign({}, searchResults), { data: searchResults.data.map(LmsIntegrationDomainService.fromJSON) });
        });
    }
    static getEnabledLmsIntegration() {
        return FetchService.getSingleResponse(BASE_URL + "/getEnabledLmsIntegration");
    }
    static testConnection() {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.get(BASE_URL + "/testConnection");
        });
    }
}
